import React, { FC, useLayoutEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { GridRowId, useGridApiContext } from '@mui/x-data-grid-pro';

import { IJobDTO } from 'src/api/dtos';
import { JobPopover } from 'src/features/jobs';
import { ChevronDownIcon } from 'src/shared/components';

interface Props {
  id: GridRowId;
  field: string;
  startDate: string;
  endDate: string;
  level: number;
  job: IJobDTO | undefined;
  onJobChange: (job: IJobDTO | undefined) => void;
}

export const TimesheetJobEditCell: FC<Props> = ({ id, field, startDate, endDate, level, job, onJobChange }) => {
  const theme = useTheme();
  const apiRef = useGridApiContext();

  const ref = useRef(null);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const label = job?.values[0] ? `${job.values[0].value} - ${job.values[0].description}` : undefined;
  const open = Boolean(anchorEl);

  const handleOpen = () => {
    setAnchorEl(ref.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
    apiRef.current.stopCellEditMode({ id, field });
  };

  const handleSelect = (job: IJobDTO) => {
    onJobChange(job);
    handleClose();
  };

  useLayoutEffect(() => {
    setAnchorEl(ref.current);
  }, []);

  return (
    <>
      <Stack
        ref={ref}
        direction="row"
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        padding="0 8px"
        onClick={handleOpen}
      >
        {label ? (
          <Typography fontSize="0.875rem" overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis" title={label}>
            {label}
          </Typography>
        ) : (
          <ChevronDownIcon color={theme.palette.text.secondary} style={{ marginLeft: 'auto' }} />
        )}
      </Stack>
      <JobPopover
        anchorEl={anchorEl}
        open={open}
        level={level}
        startDate={startDate}
        endDate={endDate}
        selected={job}
        onSelect={handleSelect}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          paper: { sx: { width: 250, borderRadius: '8px' } },
        }}
      />
    </>
  );
};
